import HttpFactory from '@/mixins/http.factory';
import TagsInput from '@/components/Inputs/TagsInput'
import HtmlEditor from '@/components/Inputs/HtmlEditor'
import { Select, Option } from 'element-ui'

import customAgGrid from '@/components/custom-ag-grid/custom-ag-grid.vue';
import dateTimeRenderer from '@/components/custom-ag-grid/dateTimeRenderer/dateTimeRenderer.vue';
import longTextRenderer from '@/components/custom-ag-grid/longTextRenderer/longTextRenderer.vue';
import title50TextRenderer from '@/components/custom-ag-grid/title50TextRenderer/title50TextRenderer.vue';
import linkAdoBtnRenderer from '@/components/zendesk-devops/search-work-item/linkAdoBtnRenderer.vue';

import Multiselect from 'vue-multiselect'
//import vSelect from 'vue-select'
//import 'vue-select/dist/vue-select.css';

export default {
	name:'search-work-item',
	mixins:[HttpFactory],
	data () {
		return {
			columnDefs:[],
			showNotifyForm:true,
			filters:{searchText:null},
			gridApi:null,
			gridOptionsApi:null,
			selectedWorkItems:[],
			htmlMessage:null,
			data: null,
			devOpsTenants:[],
			devOpsProjects:[],
            devOpsProjectData:{
                workItemTypes:[],
                nodesList:[],
                fieldsList:[],
                usersList:[],
                customFields:[]
            },
			showTags:false,
            searchData:{attachments:[],files:[],fields:[]},
			workItemsList:[],
			linkData:{workItem:null,reqType:null},
			notifyData:{attachments:[],files:[]},
			zendeskInfo: { credentials: null, user: null, ticket: null, origin: null, app_guid: null, attachments: [] },
			devOpsTenant:''
		}
	},
	created(){
		this.init();
	},
	computed:{
		selectedItemsStr:function(){
			let items=this.selectedWorkItems.map(d=>d.Id);
			return items.join(', ');
		}
	},
	beforeDestroy(){
        let _self=this;
        _self.fn().destoryEditorObj();
    },
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			//var count=0;
			modalClient.on('send_data_to_modal', (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo=data;
					_self.workItemFields(_self.zendeskInfo.userInfo.allowMultiTenant?_self.zendeskInfo.userInfo.defaultTenant:null);
					_self.fn().createHtmlEditor('editor');
					setTimeout(function(){_self.initDropzone(data);},500);
				}
			});
		},
		initDropzone(data){
			const _self=this;
			if (!data || !data.userInfo || !data.userInfo.uploadFiles) return;
			data.credentials.devOpsTenant = _self.devOpsTenant;
			_self.fn().initDropzone('div.dropzone',data.credentials,'devops',function(error,response){
				if(error){
					return;
				}
				_self.notifyData.files=_self.notifyData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.notifyData.files=_self.notifyData.files.filter(d=>d.id!=file.id);
		},
		initJSTree(devOpsProjectData){
			let _self=this;
			if(_self.zendeskInfo && _self.zendeskInfo.userInfo && _self.zendeskInfo.userInfo.allowNodes){
			
				_self.fn().createJSTree('area_jstree',function(selectedObj){
					let selPath=selectedObj.path.replace('\\Area',''); //`${_self.searchData.project.name}\\${selectedObj.text}`;
					selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
					selPath=_self.fn().handleTfsAreaIteration(selPath,'Area',_self.zendeskInfo.userInfo);
					_self.searchData.fields['System.AreaPath']=selPath;

				});
				_self.fn().createJSTree('iterations_jstree',function(selectedObj){
					let selPath=selectedObj.path.replace('\\Iteration','');//`${_self.searchData.project.name}\\${selectedObj.text}`;
					selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
					selPath=_self.fn().handleTfsAreaIteration(selPath,'Iteration',_self.zendeskInfo.userInfo);
					_self.searchData.fields['System.IterationPath']=selPath;
				});

				_self.fn().updateJSTreeData('area_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='area'));
				_self.fn().updateJSTreeData('iterations_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='iteration'));
			}
		},
		htmlEditorChange(data){
			const _self=this;
			_self.notifyData[data.referenceName]=data.htmlContent?data.htmlContent:null;
		},
		initsearchData(data,projectId){
			let _self=this;
			_self.searchData.fields={};
			_self.searchData.hdTicketId=data.hdTicketId?data.hdTicketId:data.ticket.id;
			_self.searchData.fields['System.TeamProject']=projectId?projectId:'';
			_self.searchData.fields['System.Title']='';//data.ticket.subject;
			//console.log('zendesk info',data);
			_self.searchData.fields['Microsoft.VSTS.Common.Priority']=data.ticket.priority>0?data.ticket.priority:_self.handlePrioritySet(data.ticket.priority);
			_self.searchData.fields['System.AssignedTo']='';
			_self.searchData.fields['System.WorkItemType']='';
			_self.searchData.fields['Microsoft.VSTS.Common.Severity']='';
			_self.searchData.fields['System.Tags']='';
			_self.searchData.fields['System.TagsArr'] =_self.searchData.fields['System.Tags']?_self.searchData.fields['System.Tags'].split(';'):[];
			_self.showTags=true;

			//boolean

		},
		handlePrioritySet(priority){
			let intPriority='';
			switch(priority){
				case 'low':
					intPriority=4;
					break;
				case 'normal':
					intPriority=3;
					break;
				case 'high':
					intPriority=2;
					break;
				case 'urgent':
					intPriority=1;
					break;
			}
			return intPriority;
		},
		setDefaultTenantFn(devOpsTenants) {
			let _self = this;
			if (devOpsTenants && devOpsTenants.length > 0) {
				
				let devOpsTenantData = devOpsTenants.find(d=>d.organizationName==_self.zendeskInfo.userInfo.defaultTenant);
				
				if (devOpsTenantData) _self.searchData.devOpsTenant = devOpsTenantData.organizationName;
				else _self.searchData.devOpsTenant = devOpsTenants[0].organizationName;
			}
		},
		workItemFields(devOpsTenant){
			let _self=this;
			_self.devOpsTenant = devOpsTenant;
			_self.devOpsProjectsFn(devOpsTenant, function (projectsResp) {
				if (projectsResp.data.organizations) {
					_self.devOpsTenants = projectsResp.data.organizations;
				}
				let devOpsProjects=projectsResp.data.Data.value;
				_self.htmlMessage=projectsResp.data.htmlMessage;
				if(devOpsProjects && devOpsProjects.length>0){
					_self.searchData.projectId= devOpsProjects[0].id;
					_self.getDevOpsProjectData(function(devOpsProjectData){
						_self.devOpsProjects=devOpsProjects;
						//_self.fn().showLoader(false);//as we need search auto
						setTimeout(function(){_self.initJSTree(devOpsProjectData);},1000);
						setTimeout(function(){_self.searchWorkItemFn();},1500);
					})
				}
				
			});
		},
		resetPageData() {
			let _self = this;
			_self.devOpsProjects = [];
			_self.devOpsProjectData = {
				workItemTypes: [],
				nodesList: [],
				fieldsList: [],
				usersList: [],
				customFields: [],
			};
			_self.searchData = { attachments: [], files: [], fields: {}, relations: {} };
		},
		async getDevOpsTenantData(cb){
			let _self = this;
			_self.resetPageData();
			_self.resetNotifyForm();
			_self.modifySearch();

			//setDefaultProjectFn
			_self.workItemFields(_self.devOpsTenant);
			setTimeout(function(){_self.initDropzone(_self.zendeskInfo);},500);
		},
		getDevOpsProjectData(cb){
			let _self=this;
			let projectId=_self.searchData.projectId;
			_self.initsearchData(_self.zendeskInfo,projectId);
			_self.devOpsProjectDataFn(projectId,_self.devOpsTenant,function(data){
				let devOpsProjectData=data.data.Data;
				_self.devOpsProjectData=devOpsProjectData;
				if(cb) cb(devOpsProjectData);
				else{
					_self.fn().showLoader(false);
					_self.fn().updateJSTreeData('area_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='area'));
					_self.fn().updateJSTreeData('iterations_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='iteration'));
					//setTimeout(function(){_self.applyDatePicker();},1000);
				}
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the azure devops does not have required permissions.',
					'Can you please create azure devops token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000451379-how-to-create-azure-devops-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		async validateForm(reqType){
			this.linkData.reqType=null;
			let isValid=await this.$validator.validateAll();
			
			if(!isValid){
				this.userMsg={show:true,type:'danger',list:[`Please scroll up and fill all required fields.`]}
			}else if(reqType){
				this.linkData.reqType=reqType;
			}
			return isValid;
		},
		//create init
	    devOpsTenantDataFn:function(devOpsTenantId,successCb,errorCb){
            var _self=this;
            var url = `dev-ops/tenants/${devOpsTenantId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        devOpsProjectsFn:function(devOpsTenant,successCb,errorCb){
			var _self = this;
			let data = {};
			if (devOpsTenant) data.devOpsTenant = devOpsTenant;
            var url = `dev-ops/projects`;
            _self.fn().clearMessage();
			_self.postServerFn(url,data,successCb,errorCb);
        },
        devOpsProjectDataFn:function(projectId,devOpsTenant,successCb,errorCb){
            var _self=this;
			let data = {};
			if (devOpsTenant) data.devOpsTenant = devOpsTenant;
            var url = `dev-ops/projects/${projectId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,data,successCb,errorCb);
        },
		searchWorkItemFn(){
			let _self=this;
			_self.fn().clearMessage();
			_self.selectedWorkItems=[];
			_self.searchData.fields['System.Tags']=_self.searchData.fields['System.TagsArr']?_self.searchData.fields['System.TagsArr'].join(';'):'';
			//_self.searchData.fields['System.TeamProject']=_self.searchData.projectId;
			let data={..._self.searchData};
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.project=_self.devOpsProjects.find(d=>d.id==data.projectId);
			data.fields['System.TeamProject'] = data.project ? data.project.name : null;
			if (_self.devOpsTenant) data.devOpsTenant = _self.devOpsTenant;
			delete data.fields['System.TagsArr'];
			let url=`dev-ops/workitems/search`;
			_self.postServerFn(url,data,function(response){
				_self.fn().showLoader(false);
				if(response.data.Success){
					_self.showTags=false;
					_self.searchData.fields['System.TagsArr']=_self.searchData.fields['System.Tags']?_self.searchData.fields['System.Tags'].split(';'):[];
					setTimeout(function(){_self.showTags=true;},1000);
					if(response.data.Data && response.data.Data.value){
						_self.workItemsList=response.data.Data.value;
					}else{
						_self.workItemsList=[];
						_self.userMsg={show:true,type:'danger',list:[`No results found in the search`]}
					}
				}
			},function(error){ 
				_self.fn().showLoader(false);
				_self.showTags=false;
				_self.searchData.fields['System.TagsArr']=_self.searchData.fields['System.Tags']?_self.searchData.fields['System.Tags'].split(';'):[];
				setTimeout(function(){_self.showTags=true;},1000);
				_self.commonErrorMsgDisp(error);
			});
		},
		modifySearch(){
			const _self=this;
			_self.fn().clearMessage();
			_self.workItemsList=[];
			_self.linkData.workItem=null;
		},
		workItemLog(){
			let _self=this;
			_self.fn().clearMessage();
			if(!this.isWorkItemSelected()) return;
			var size={ width: '80vw',height: '100vh'};
			let linkData={hdTicketId:_self.zendeskInfo.ticket.id,workItemId:_self.linkData.workItem.id};
			_self.zendeskInfo.linkData=linkData;
			let triggerInstance=`work-item-log-dialog_zd${linkData.hdTicketId}_wd${linkData.workItemId}`;
			let action=`/work-item-log?hdTicketId=${linkData.hdTicketId}&workItemId=${linkData.workItemId}&devOpsTenant=${linkData.devOpsTenant}`;
			_self.fn().create_zendesk_modal(action,size,triggerInstance,null,_self.zendeskInfo,function(){
				//_self.getAppData();
			});
		},
		submitReqForm(){
			const _self=this;
			_self.fn().clearMessage();
			if(!this.isWorkItemSelected()) return;
			if(this.linkData.reqType==1){
				this.notifyWorkItemFn()
			}

			if(this.linkData.reqType==2){
				this.linkWorkItemFn();
			}
		},
		isWorkItemSelected(){
			this.fn().clearMessage();
			if(!this.linkData.workItemId){
				let userMsg={show:true,type:'danger',list:[`Please select work item #`]}
				this.userMsg=userMsg;
				return false;
			}else{
				return true;
			}
		},
		linkWorkItemFn(isSingle){
			let _self=this;
			_self.fn().clearMessage();

			let data=_self.linkData;
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.workItemIds=data.workItemIds?data.workItemIds:[data.workItemId];
			data.devOpsTenant = _self.devOpsTenant;
			var url=`zendesk/links/${_self.zendeskInfo.ticket.id}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					_self.data=response.data.Data;
					if(isSingle) _self.userMsg={show:true,type:'success',list:[response.data.Data]}
					else _self.sendDataToParent(response.data);
				}else{
					_self.userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`An error occurred!!! Please try again later...`]}
				}
				_self.clearSelection();
				
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		resetNotifyForm() {
			let _self = this;
			
			_self.fn().clearHtmlEditorContent();
			_self.notifyData.commentText=null;
			_self.notifyData.files=[];
			_self.notifyData.attachments=[];
			_self.showNotifyForm=false;
			setTimeout(function () { _self.showNotifyForm = true; }, 500);
			
			_self.clearSelection();
		},
		notifyWorkItemFn(){
			let _self=this;
			_self.fn().clearMessage();
			let data=_self.notifyData;
			if(_self.editorObj)
            	data.commentText=_self.fn().getHtmlEditorContent();
            
			if(!data.commentText || data.commentText.trim()==''){
				_self.userMsg={show:true,type:'danger',list:[`Please enter the comment description`]}
				return;
			}
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.hdTicketId=_self.zendeskInfo.ticket.id;
			data.workItemIds=_self.linkData.workItemIds?_self.linkData.workItemIds:[];
			data.devOpsTenant = _self.devOpsTenant;
			let url=`zendesk/notify/${data.hdTicketId}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`WorkItem notified Successfully`]}
					_self.userMsg=userMsg;
					_self.resetNotifyForm();
					//_self.closeDialog();
				}else{
					_self.userMsg = { show: true, type: 'danger', list: [`An error occurred!!! Please try again later...`] }
					_self.clearSelection();
				}
				
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		},
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		},
		onAgGridReady(params){
			this.gridApi=params.api;
		},
		onGridOptionsApi(params){
            this.gridOptionsApi=params;
        },
		async filterData(){
            const _self=this;
            const searchText=_self.filters.searchText;
            _self.gridOptionsApi.api.setQuickFilter(searchText);
        },
		//link
		extraCallBackFn(params){
			const _self=this;
			//_self.linkData.hdTicketId=_self.zendeskInfo.ticket.id;
			_self.linkData.workItemId=params.data['Id'];
			_self.linkData.workItemIds=[_self.linkData.workItemId]
			_self.linkWorkItemFn(true);
		},
		extraCallBackFn1(params){
			const _self=this;
		},
		onAgGridSelectionChanged(params){
			const _self=this;
			_self.selectedWorkItems=_self.getSelectedRowData();
			console.log('selected',params);
		},
		getSelectedRowData() {
			let selectedNodes = this.gridApi.getSelectedNodes();
			let selectedData = selectedNodes.map(node => node.data);
			console.log(`Selected Nodes:\n`,selectedData);
			return selectedData;
		},
		linkAllSelectedADO(){
			const _self=this;
			_self.linkData.workItemIds=_self.selectedWorkItems.map(d=>d['Id']);
			_self.linkData.workItemId=_self.linkData.workItemIds[0];
			_self.linkWorkItemFn(false);
		},
		notifySelectedADOFn(){
			const _self=this;
			_self.linkData.workItemIds=_self.selectedWorkItems.map(function (item){
				let project=_self.devOpsProjects.find(d=>d.name==item['TeamProject']);
				return {
					id:item['Id'],
					projectId: project ? project.id : _self.searchData.project.id,
					devOpsTenant:_self.devOpsTenant
				};

			});
			_self.linkData.workItemId=_self.linkData.workItemIds[0];
			_self.notifyWorkItemFn();
		},
		getADOUrlFromApi(url,data){
			let project=data['TeamProject'];
			url=url.replace('_apis/wit',project);
			url=url.replace('workItems/','_workItems/edit/')
			return url;
		},
		clearSelection(manual){
			const _self=this;
			_self.gridOptionsApi.api.deselectAll();
			_self.selectedWorkItems=[];
			if(manual){
				_self.fn().clearMessage();
			}
		}
	},
	components:{HtmlEditor,TagsInput,[Select.name]: Select,[Option.name]: Option,customAgGrid},
	beforeMount() {
		let _self  =this;
		let commonWidth=150;//=120;
		_self.columnDefs = [
			{ headerName: 'Workitem #',pinned:'left', field: 'Id', width:commonWidth,checkboxSelection: true,
				cellRenderer:function(params){
					return `<a href="${_self.getADOUrlFromApi(params.data.url,params.data)}" target="_blank">${params.value}</a>`;
				}	
			},
			{ headerName: 'Project', field: 'TeamProject', width:commonWidth},
			{ headerName: 'Area', field: 'AreaPath', width:commonWidth},
			{ headerName: 'Iteration', field: 'IterationPath', width:commonWidth},
			//{ headerName: 'Title', field: 'Title', width:commonWidth},
			{ headerName: 'Title', field: 'Title', width:commonWidth,minWidth: 250,maxWidth:550,
				cellStyle: { 'white-space': 'normal' }, minHeight: 200,
				autoHeight: true, // Enable auto height for this column
				wrapText: true, // Allow text wrapping
				valueFormatter: function (params) {
					let val = params.value;
					return _self.filter().stripHtml(val);
				},
				cellRendererFramework:title50TextRenderer,
					
			},
			{ headerName: 'State', field: 'State', width:commonWidth},
			{ headerName: 'Type', field: 'WorkItemType', width:commonWidth},
			{ headerName: 'Priority', field: 'Priority', width:commonWidth},
			{ headerName: 'Tags', field: 'Tags', width:commonWidth},
			{ headerName: 'Description', field: 'Description', width:commonWidth,minWidth: 450,maxWidth:550,
				cellStyle: { 'white-space': 'pre-line' }, minHeight: 200,
				autoHeight: true, // Enable auto height for this column
		        wrapText: true, // Allow text wrapping
				valueFormatter: function (params) {
					let val = params.value;
					return _self.filter().stripHtml(val);
				},
				cellRendererFramework:longTextRenderer,
					
			},
			
			{ headerName: 'Assigned To', field: 'AssignedTo', width:commonWidth,
				getQuickFilterText: params => {return params.value?params.value['displayName']:'Not Assigned';},
				valueFormatter:function(params){return params.value?params.value['displayName']:'Not Assigned'}	
			},
			{ headerName: 'Created By', field: 'CreatedBy', width:commonWidth,
				getQuickFilterText: params => {return params.value['displayName'];},
				valueFormatter:function(params){return params.value['displayName'];}	
			},
			{ headerName: 'Created On', field: 'CreatedDate', width:commonWidth,cellRendererFramework:dateTimeRenderer},
			{ headerName: 'Actions',pinned:'right', field: 'Id',autoHeight:true, width:commonWidth,cellRendererFramework:linkAdoBtnRenderer	},
		];
	}
}

